export default __webpack_public_path__ + "static/media/ARVORE-BRANCA.6161acfe.png";